'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toggle = function Toggle(_ref) {
  var on = _ref.on,
      onClick = _ref.onClick,
      onText = _ref.onText,
      offText = _ref.offText,
      size = _ref.size,
      disabled = _ref.disabled;

  return _react2.default.createElement(
    'div',
    {
      className: 'toggle' + (size ? ' toggle-' + size : '') + ' toggle-' + (on ? 'on' : 'off') + ' ' + (disabled ? 'disabled' : 'clickable'),
      onClick: disabled ? null : onClick },
    _react2.default.createElement(
      'div',
      { className: 'toggle-label' },
      on ? onText : offText
    ),
    _react2.default.createElement('div', { className: 'toggle-switch' })
  );
};

Toggle.propTypes = {
  on: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  onText: _propTypes2.default.string,
  offText: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['sm']),
  disabled: _propTypes2.default.bool
};

Toggle.defaultProps = {
  onText: 'On',
  offText: 'Off',
  disabled: false
};

exports.default = Toggle;